/**
* @Author: 858834013@qq.com
* @Name: tabs
* @Date: 2022-6-14
* @Desc:

*/
<template>
  <div class="tabs">
    <div class="tab cur" :class="{active:active==item.id}" @click="getactive(item.id)" v-for="(item,index) in list"
         :key="index"><span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabs",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    active: {
      type: Number,
      default() {
        return 0;
      }
    },
  },
  methods: {
    getactive(e) {
      this.$emit('update:active', e)
    },
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 202px;
  height: 24px;
  border: 1px solid #4472cb;

  .tab {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1;
    cursor: pointer;


    span {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 500;
      color: #46BCFF;
      opacity: 0.5;
    }
  }

  .tab.active {
    background: url("../../../../assets/home/tabbg.png");
    background-size: 100% 100%;

    span {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 500;
      color: #46BCFF;
      opacity: 1;
    }
  }
}
</style>
